/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $, SCS) {
	'use strict';

	var SearchResultQueryBox = Module.extend({
		// The container module instance (for setting config changes and the like)
		searchContainer: null,
		// The search processor instance for autosuggest and keymatches
		// FIXME: Implement (or remove)
		searchProcessor: null,

		on: function(callback) {
			callback();
		},

		after: function() {
			this.findElements();
			this.attachListeners();
		},

		initSearch: function(searchContainer) {
			this.searchContainer = searchContainer;
		},

		searchConfigUpdated: function(searchConfig) {
			this.$field.val(searchConfig.query);
		},

		findElements: function() {
			this.$field = this.$ctx.find('.scs-sitesearch-searchfield-input');
		},

		attachListeners: function() {
			var mod = this;
			mod.$ctx.on('submit', function(event) {
				event.preventDefault();
				var query = mod.$field.val();
				mod.searchContainer.query = query;
				mod.searchContainer.configChanged();
			});
		}

	});

	Module.SearchResultQueryBox = SearchResultQueryBox;

})(window.Tc.Module, window.Tc.$, window.SCS = window.SCS || {});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchResultQueryBox.js
// module id = 75
// module chunks = 0